<template>
	<div v-if="chartInfo" class="finance-tab">
		<ja-pie-chart
			v-if="chartInfo.NMI"
			:data="chartInfo.NMI"
			legend="row"
			class="chart"
		></ja-pie-chart>
		<ja-pie-chart
			v-if="chartInfo.savings"
			:data="chartInfo.savings"
			legend="row"
			class="chart"
		></ja-pie-chart>
		<ja-pie-chart
			v-if="chartInfo.debt && !lifeStageIsTeenager"
			:data="chartInfo.debt"
			legend="row"
			class="chart"
		></ja-pie-chart>
	</div>
</template>
<script>
import LifeStageData from '@/mixins/LifeStageData';
import ProfileData from '@/mixins/ProfileData';
import ChartData from '@/mixins/ChartData';
import Savings from '@/mixins/Savings';
import PieChart from '../Chart/PieChart';

export default {
	components: {
		jaPieChart: PieChart
	},
	mixins: [LifeStageData, Savings, ProfileData, ChartData],
	computed: {
		debts() {
			return this.$store.getters.debts;
		},
		chartInfo() {
			let result = null;
			if (this.lifeStageData && this.savingsSubcategories && this.debts) {
				const fullDebtAmount =
					this.debts.creditCard.amount + this.debts.educationLoan.amount;
				result = {
					NMI: this.getNMIChart(this.lifeStageData),
					savings: this.getSavingsChart(this.savingsSubcategories, {
						amountProp: 'amount',
						isPerMonth: true
					}),
					debt: {
						title: this.$t('debt'),
						ariaLabel: this.$t('monthlyDebtChart', { amount: fullDebtAmount }),
						fullAmount: fullDebtAmount,
						dataset: [
							{
								title: this.$t('creditCard'),
								value: this.debts.creditCard.amount,
								ariaLabel: this.$t('creditCardChart', {
									amount: this.debts.creditCard.amount
								})
							}
						]
					}
				};
				if (!this.educationIsFree) {
					result.debt.dataset.push({
						title: this.$t('postLoans'),
						value: this.debts.educationLoan.amount,
						ariaLabel: this.$t('postLoanChart', {
							amount: this.debts.educationLoan.amount
						})
					});
				}
			}
			return result;
		}
	}
};
</script>
<style lang="scss" scoped>
.finance-tab {
	.chart {
		&:not(:last-child) {
			margin-bottom: 32px;
		}
	}
}
</style>
